module.exports = __webpack_public_path__ + "static/media/plastic.11e357b0.jpg";